/**
 * Réserve un écran aux superadministrateurs de l'annuaire.
 *
 * Plus étroit que `admin` : le rôle porté par cette seule application ne suffit
 * pas. À déclarer par `definePageMeta({ middleware: 'superadmin' })`.
 *
 * Ce n'est pas la protection — les routes appelées vérifient elles-mêmes le
 * rôle via `requireGlobalSuperAdmin`. Il évite seulement d'ouvrir un écran dont
 * chaque action échouerait en 403.
 */
export default defineNuxtRouteMiddleware(() => {
  const auth = useAuthStore()

  // La session peut n'être pas encore chargée au premier rendu : `auth.global`
  // l'a demandée, et laisser passer ici évite un renvoi injustifié. Les routes
  // restent gardées côté serveur.
  if (auth.loading) return

  // Profil de secours : les droits n'ont pas pu être lus. Le dire plutôt que
  // de refuser comme si le compte n'y avait pas droit.
  if (auth.profilNonVerifie) {
    throw createError({
      statusCode: 503,
      statusMessage: 'Vos droits n\'ont pas pu être vérifiés : le service d\'authentification est injoignable. Rechargez la page dans un instant.',
      fatal: true,
    })
  }

  if (!auth.isGlobalSuperAdmin) {
    throw createError({
      statusCode: 403,
      statusMessage: 'Accès réservé aux superadministrateurs de l\'annuaire',
      fatal: true,
    })
  }
})
